<template lang="pug">
	Auth(:type="type" @done="onDone" @changeState="setType" )
				
</template>

<script>
import Auth from "../templates/Auth";
import { ref, onMounted } from "@vue/composition-api";
import { auth } from "../firebase.config";
import { mapActions } from "vuex";

export default {
  name: "SignIn",
  data() {
    return {
      type: "signIn"
    };
  },
  components: { Auth },
  methods: {
    ...mapActions(["signInWithGoogle", "test", "signUpForm"]),
    onDone() {
      this.$router.push("/");
    },
    setType(state) {
      this.type = state;
    }
  }
};
</script>
<style lang="sass" scoped>
img
	height: 400px
</style>
